import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import { ClickIt, ConfirmationWithTriggersTitle } from "../../../Constants/Constants";
import { ConfirmationWithTriggersSubTitle } from "../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const ConfirmationWithTriggers = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
        });
      }
    });
  };
  return (
    <Col xxl="3" xl="4" sm="6" xs="12" className="box-col-4">
      <Card className="height-equal">
        <CommonCardHeader title={ConfirmationWithTriggersTitle} span={ConfirmationWithTriggersSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ConfirmationWithTriggers;
